import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import useApi from "../../api";
import moment from "moment";
import ApplicableProducts from "./applicableProduct";
import ApplicableCustomer from "./applicableCustomer";


function PromoCodeDetails({ isOpen, onClose, id }: {isOpen: boolean; onClose: () => void; id: | null}) {
  const [promocode, setPromocode] = useState<any>({});
  const [openApplicableProducts, setOpenApplicableProducts] = useState(null);
  const [applicableCustomer, setApplicableCustomer] =  useState(null);
  const api = useApi()

  useEffect(() => {
    api.getPromocode(id).then((response) => {
        setPromocode(response)
    }, (error) => {
        toast.error("Failed to fetch promocode details")
    })
    
  }, [id]);

  return (
    <NxtbnDrawer title={`Promocode Details - ${promocode.code || ""}`} isOpen={isOpen} onClose={onClose}>
       <div className="p-4 space-y-6 bg-gray-50">
        {/* General Info */}
        <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">General Info</h2>
          </div>
          <div className="p-4 space-y-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-sm">
                <span className="text-gray-500">Code:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.code}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Type:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.code_type}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Value:</span>{" "}
                <span className="font-medium text-gray-900">
                  {promocode.code_type === "FIXED" ? `$${promocode.value}` : `${promocode.value}%`}
                </span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Status:</span>{" "}
                <span className={`font-medium ${promocode.is_active ? "text-green-600" : "text-red-600"}`}>
                  {promocode.is_active ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
            <div className="text-sm pt-2">
              <span className="text-gray-500">Description:</span>{" "}
              <span className="font-medium text-gray-900">{promocode.description || "No description"}</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
              <div className="text-sm">
                <span className="text-gray-500">Created At:</span>{" "}
                <span className="font-medium text-gray-900">
                  {moment(promocode.created_at).format("MMM D, YYYY")}
                </span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Last Modified:</span>{" "}
                <span className="font-medium text-gray-900">
                  {moment(promocode.last_modified).format("MMM D, YYYY")}
                </span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Expiration Date:</span>{" "}
                <span className="font-medium text-gray-900">
                  {promocode.expiration_date ? moment(promocode.expiration_date).format("MMM D, YYYY") : "No Expiration"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Restrictions */}
        <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">Restrictions</h2>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-sm">
                <span className="text-gray-500">Minimum Purchase Amount:</span>{" "}
                <span className="font-medium text-gray-900">${promocode.min_purchase_amount}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Minimum Purchase Period:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.min_purchase_period}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Redemption Limit:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.redemption_limit}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">Usage Limit per Customer:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.usage_limit_per_customer}</span>
              </div>
              <div className="text-sm">
                <span className="text-gray-500">New Customers Only:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.new_customers_only ? "Yes" : "No"}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">Additional Info</h2>
          </div>
          <div className="p-4 space-y-4">
            <div className="flex justify-between items-center border-b border-gray-100 pb-3">
              <div className="text-sm">
                <span className="text-gray-500">Total Redemptions:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.total_redemptions}</span>
              </div>
              <button className="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded px-2 py-1 transition-colors">
                See All Redemptions
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </div>

            <div className="flex justify-between items-center border-b border-gray-100 pb-3">
              <div className="text-sm">
                <span className="text-gray-500">Total Applicable Products:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.total_applicable_products}</span>
              </div>
              <button 
                onClick={() => setOpenApplicableProducts(promocode.code)} 
                className="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded px-2 py-1 transition-colors"
              >
                See Applicable Products
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </div>

            <div className="flex justify-between items-center">
              <div className="text-sm">
                <span className="text-gray-500">Total Specific Customers:</span>{" "}
                <span className="font-medium text-gray-900">{promocode.total_specific_customers}</span>
              </div>
              <button 
                onClick={() => setApplicableCustomer(promocode.code)} 
                className="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded px-2 py-1 transition-colors"
              >
                See Assigned Customers
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {openApplicableProducts && <ApplicableProducts isOpen={openApplicableProducts ? true: false} code={openApplicableProducts} onClose={() => setOpenApplicableProducts(null)} /> }
        {applicableCustomer && <ApplicableCustomer isOpen={applicableCustomer ? true: false} code={applicableCustomer} onClose={() => setApplicableCustomer(null)} /> }

      </div>
    </NxtbnDrawer>
  );
}

export default PromoCodeDetails;